import { createQueryKeys } from '../../factories';

export const INTEGRATION_SSH_KEY_NAMESPACE = ['integration', 'sshkeys'];
export const integrationSSHKeyQueryKeyFactory = createQueryKeys(
	INTEGRATION_SSH_KEY_NAMESPACE
);
